module.exports = __webpack_public_path__ + "img/creations-header.90ff9d84.png";